module.exports = __webpack_public_path__ + "img/new-step3.33bac159.jpg";